import React from 'react';
import { DossierPage } from './pages/DossierPage';
interface AppProps {
  /** Cupos restantes mostrados en la barra de urgencia. */
  spotsLeft?: number;
  /** Revela los folios narrativos con barras de censura al entrar en pantalla. */
  redactedIntros?: boolean;
}
export function App({
  spotsLeft = 14,
  redactedIntros = true
}: AppProps) {
  return <DossierPage spotsLeft={spotsLeft} redactedIntros={redactedIntros} data-id="element-0" data-mp="3fb9hn5zs34kz" />;
}